"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Typography = _interopRequireDefault(require("./../../Typography"));

var _EDSApplication = require("./../../EDSApplication");

var _styles = require("./../../styles");

var _ErrorPageAction = _interopRequireDefault(require("./ErrorPageAction"));

var _tokens = require("./../../styles/tokens");

var styles = function styles(theme) {
  return {
    root: {},
    errorTemplate: {},
    noHeader: {},
    illustration: {
      width: '100%',
      objectFit: 'contain'
    },
    errorDetails: {
      textAlign: 'center',
      padding: _tokens.spacing40,
      '& h2': {
        marginBottom: _tokens.spacing50
      },
      '& a': {
        marginTop: _tokens.spacing40,
        display: 'inline-block'
      }
    }
  };
};

var ErrorTemplateBody = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var classes = props.classes,
      largeIllustrationName = props.largeIllustrationName,
      errorTitle = props.errorTitle,
      errorMessage = props.errorMessage,
      message = props.message,
      imageSrc = props.imageSrc,
      hasAction = props.hasAction,
      action = props.action,
      text = props.text;

  var illustrationUrl = _EDSApplication.cdn.getLargeIllustrationsUrl(largeIllustrationName);

  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: classes.illustration,
    src: imageSrc || illustrationUrl,
    alt: ""
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.errorDetails
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h2"
  }, errorTitle), /*#__PURE__*/_react.default.createElement(_Typography.default, null, message || errorMessage), hasAction && /*#__PURE__*/_react.default.createElement(_ErrorPageAction.default, {
    action: action,
    text: text
  })));
});

ErrorTemplateBody.propTypes = {
  largeIllustrationName: _propTypes.default.string,
  classes: _propTypes.default.object,
  errorTitle: _propTypes.default.string,
  errorMessage: _propTypes.default.string,
  message: _propTypes.default.string,
  imageSrc: _propTypes.default.string,
  text: _propTypes.default.string,
  hasAction: _propTypes.default.bool,
  action: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string])
};

var _default = (0, _styles.withStyles)(styles)(ErrorTemplateBody);

exports.default = _default;